import IOwner from 'src/models/IOwner';
import OwnerJointTenantOwner from './OwnerJointTenantOwner';
import Address from 'src/models/Address';
import PhoneNumberChanges from 'src/models/PhoneNumberChanges';

export default class OwnerJointTenant implements IOwner {
    constructor(owner: OwnerJointTenant) {
        Object.assign(this, owner);
    }

    id: number;
    ownerType: string;
    name: string;
    projectId: number;
    isClientAcreage: boolean;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
    email: string;
    phoneNumber: string;
    note: string;
    ownerLookUpId?: number;
    ssnTaxId: string;
    address?: Address;
    phoneNumberChanges?: PhoneNumberChanges;

    tenantOwners?: OwnerJointTenantOwner[];

    ownerName = () => {
        return this.name;
    };
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/add_ownership_revised/OwnerJointTenant.ts